class LqdCustomMenuHandler extends elementorModules.frontend.handlers.Base {

  onInit(...args) {

    super.onInit(...args);

    this.initMoveElement();
    this.initPin();
    this.initLocalScroll();
    this.initInview();

  }

  getDefaultSettings() {
    return {
      selectors: {
        moveElementElement: '[data-move-element]',
        pinElement: '[data-pin=true]',
        localScrollElement: '[data-localscroll]',
        inviewElement: '[data-inview]',
      }
    }
  }

  getDefaultElements() {
    const selectors = this.getSettings('selectors');
    return {
      $pinElement: this.$element.find(selectors.pinElement),
      $moveElementElement: this.$element.find(selectors.moveElementElement),
      $localScrollElement: this.$element.find(selectors.localScrollElement),
      $inviewElement: this.$element.find(selectors.inviewElement),
    }
  }
  
  initMoveElement() {

    this.elements.$moveElementElement.liquidMoveElement();
    
  }

  initPin() {

    this.elements.$pinElement.liquidPin();
    
  }
  
  initLocalScroll() {
    
    this.elements.$localScrollElement.liquidLocalScroll();

  }

  initInview() {

    this.elements.$inviewElement.liquidInView();

  }
  
}

export default ($element) => {
  elementorFrontend.elementsHandler.addHandler( LqdCustomMenuHandler, { $element } );
};